export enum Mode {
  NORMAL = "NORMAL",
  READONLY = "READONLY"
}
